import { render, staticRenderFns } from "./QuizDestination.vue?vue&type=template&id=5949dbf4&scoped=true&"
import script from "./QuizDestination.vue?vue&type=script&lang=js&"
export * from "./QuizDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5949dbf4",
  null
  
)

export default component.exports